export const CHANNEL_APP = 1
export const CHANNEL_SMS = 2
export const CHANNEL_EMAIL = 3
export const CHANNEL_CALL = 9

export const TWITTER_VALUE = 4
export const FACEBOOK_VALUE = 5
export const INSTAGRAM_VALUE = 7
export const LINKEDIN_VALUE = 8
export const LINE_VALUE = 10
export const WHATAPP_VALUE = 11

export const SOCIAL_LINE = 'line'
export const SOCIAL_WHATAPP = 'whatApp'
export const SOCIAL_LINKEDIN = 'linkedIn'
export const SOCIAL_TWITTER = 'twitter'
export const SOCIAL_FACEBOOK = 'facebook'
export const SOCIAL_INSTAGRAM = 'instagram'

export const APP_COUNT = 'applicationCount'
export const EMAIL_COUNT = 'emailCount'
export const SMS_COUNT = 'smsCount'
export const AUTOMATED_CALL_COUNT = 'automateCallCount'
export const SUBSCRIBER_COUNT = 'subscriberCount'

export const filterChannels = (appName) => [
  {
    id: 1,
    name: CHANNEL_APP,
    label: 'subscriber.filter.notification.method.app',
    valueLabel: { appName: appName },
    value: CHANNEL_APP,
  },
  {
    id: 2,
    name: CHANNEL_SMS,
    label: 'subscriber.filter.notification.method.sms',
    value: CHANNEL_SMS,
  },
  {
    id: 3,
    name: CHANNEL_EMAIL,
    label: 'subscriber.filter.notification.method.email',
    value: CHANNEL_EMAIL,
  },
  {
    id: 4,
    name: CHANNEL_CALL,
    label: 'channel.automatedCall',
    value: CHANNEL_CALL,
  },
]
